<!--  -->
<template>
  <div class="container">
    <div class="top-box">
      <div class="flexrbc">
        <div class="flexr0c">
          <div class="title-label"></div>
          <div class="title">{{ title }}</div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="list">
        <div class="list-item" v-for="(item, index) in qaList" :key="index">
          <div class="title">{{ item.quesTitle }}</div>
          <div class="txt">{{ item.ansInfo }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "onlineCharge",
  components: {},
  data () {
    return {
      fid: 1,
      pageSize: 10,
      qaList: [],
      title: "在线充值",
    };
  },
  methods: {
    getAnswer (index) {
      var session = JSON.parse(localStorage["session"]);
      this.$http
        .post({
          sessionId: session.sessionId,
          modeCode: "oSF89mYEP4m6k3aIBX0Oh7vsR10ZzXwO",
          pageIndex: index,
          pageSize: this.pageSize,
          quesMenu: window.localStorage.getItem("fid"),
        })
        .then((res) => {
          if (res.code == 1) {
            this.qaList = res.data.list;
          } else {
            this.$Message["error"]({
              background: true,
              content: res.msg,
            });
          }
        });
    },
  },
  computed: {
    ...mapState(["contentType"]),
  },
  created () {
    this.getAnswer();
    if (window.localStorage.getItem("name")) {
      this.title = window.localStorage.getItem("name");
    } else {
      this.title = "在线充值";
    }
  },
  mounted () { },
};
</script>

<style lang="less" scoped>
.container {
  width: 980px;
  height: 100%;
  text-align: center;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin-left: 20px;
  background: #fff;

  .top-box {
    background-image: linear-gradient(180deg, #ffffff 0%, #e8e9ea 100%);
    border-radius: 10px 10px 0 0;
    width: 100%;
    height: 40px;

    /deep/.ivu-input-with-suffix {
      border-radius: 15px;
    }

    & > div {
      height: 100%;
      width: 928px;
      margin: 0 auto;
    }

    .title-label {
      width: 4px;
      height: 14px;
      background: #2c59c3;
    }

    .title {
      font-family: PingFangSC-Semibold;
      font-size: 16px;
      color: #2c59c3;
      letter-spacing: 0.4px;
      margin-left: 6px;
    }
  }

  .content {
    background: #fff;
    min-height: 775px;
    width: 100%;
    // box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.10);
    border-radius: 0 0 10px 10px;

    .list {
      margin-top: 10px;

      .list-item {
        text-align: left;

        .title {
          width: 100%;
          line-height: 40px;
          background: #edeff1;
          text-indent: 36px;
          font-family: PingFangSC-Semibold;
          font-size: 14px;
          color: #666666;
          letter-spacing: 0.35px;
          font-weight: 600;
        }

        .txt {
          min-height: 80px;
          margin: 10px auto;
          padding: 0 54px 0 36px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #4a4a4a;
          letter-spacing: 0.35px;
        }
      }
    }
  }
}
</style>
